import { Component, OnInit } from '@angular/core';
import { faAngleRight, faChevronDown, faThumbsUp, faThumbsDown } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {

  public faAngleRight = faAngleRight;
  public choiceName:any;
  public fetchParam:string;
  public faChevronDown = faChevronDown;
  public faThumbsUp = faThumbsUp;
  public faThumbsDown = faThumbsDown;
  public notfs:boolean = false;
  public dispMsg:string;

  constructor() { }

  ngOnInit(): void {
    window.scrollTo(0,0);
    this.queryFor('tenant');
  }

  public queryFor(value:any) {
    if(value == 'tenant') {
      this.fetchParam = 'token';
      this.choiceName = 'tenant';
      document.getElementById('tenant').classList.add('activeClass');
      document.getElementById('owner').classList.remove('activeClass');
    }
    else {
      this.choiceName = 'owner';
      this.fetchParam = 'proplisting';
      document.getElementById('tenant').classList.remove('activeClass');
      document.getElementById('owner').classList.add('activeClass');
    }
  }
  public faqParams(value:any) {
    this.fetchParam = value;
  }
  public wasHelpful(id:any) {
    if(id == 1) {
      document.getElementById('yes').style.filter = "drop-shadow(0px 0px 4px rgba(2, 33, 36, 0.25))"; 
      document.getElementById('yes').style.border = "3px solid #0A9CDD";
      document.getElementById('yes').style.border = "drop-shadow(0px 0px 4px rgba(2, 33, 36, 0.25))";
      document.getElementById('no').style.filter = "none";
      document.getElementById('no').style.border = "2px solid black";
      this.notfs = true;
      this.dispMsg = "Thank you for your feedback!";
      this.closeNotfs();
    }
    else {
      document.getElementById('no').style.filter = "drop-shadow(0px 0px 4px rgba(2, 33, 36, 0.25))";
      document.getElementById('no').style.border = "3px solid #E01D24";
      document.getElementById('no').style.border = "drop-shadow(0px 0px 4px rgba(2, 33, 36, 0.25))";
      document.getElementById('yes').style.filter = "none";
      document.getElementById('yes').style.border = "2px solid black";
      this.notfs = true;
      this.dispMsg = "Thank you for your feedback!";
      this.closeNotfs();
    }
  }
  public closeNotfs() {
    setTimeout(() => {
      this.notfs = false;
    }, 3000);
  }
}
